import React, {useContext, useState, useEffect} from 'react'
import "../styles/riquadroVerdeManifesto.scss"
import {Languages} from "./Home"
import icona_manifesto from "../assets/icone/logo piccolo verde.svg"

export default function RiquadroVerdeManifesto() {
    const lang = useContext(Languages)
    const posizionePartenza = -300
    const dimensioni = [1500, 1500, 1500, 1500, 1500, 1500 ,1500 ,1500, 1500, 1500, 1500, 1500, 1500, 1500 ,1500 ,1500, 1500]
    const idealWidth = 1920;
    const maxWidth = 330;
    const minWidth = 165;

    // Stato per memorizzare la larghezza attuale della finestra
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);

    // Funzione per gestire il cambiamento delle dimensioni della finestra
    const handleResize = () => {
        setScreenWidth(window.innerWidth);
    };

    // Effetto per aggiungere e rimuovere l'ascolto degli eventi di ridimensionamento
    useEffect(() => {
        window.addEventListener('resize', handleResize);

        // Pulisci l'ascoltatore degli eventi al momento della disconnessione dell'effetto
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // Calcola la proporzione in base alla larghezza attuale della finestra
    const proportion = screenWidth / idealWidth;

    return (
        <div className='riquadro_verde_maniefesto'>
            {dimensioni.map((elem, index) => {
            let width = 330 * proportion;
            let widthSubstract = 30 * proportion;
            widthSubstract = widthSubstract <= 30 ? widthSubstract : 30;
            widthSubstract = widthSubstract <= 15 ? 15 : widthSubstract;

            // Limita la larghezza massima a 330 e la larghezza minima a 180
            width = Math.min(Math.max(width, minWidth), maxWidth);

            // Calcola il ritardo per ciascuna colonna (ad esempio, 0.2s, 0.4s, 0.6s, ecc.)
            const delay = 0.2 * index + "s";

            // Applica la classe CSS e il ritardo
            const columnClassName = "column c" + index + " column-animation";
            const columnStyle = {
                left: posizionePartenza + width * index,
                height: elem,
                width: width - widthSubstract,
                animationDelay: delay, // Applica il ritardo all'animazione
            };
                return (
                    <div key={index} className={columnClassName} style={columnStyle}/>
                )
            })}
            <div className='riquadro_bianco_manifesto max-w' data-aos="fade-up" data-aos-duration="1000">
                    <img src={icona_manifesto} className='icona_manifesto'/>
                    {/*<p className='testo_generico'>
                        {lang['Crediamo che acquistare una casa debba essere']}<br />
                        {lang['Questo è il nostro manifesto']}<br />
                        {lang['questo è']}&nbsp;<b>BLEND</b>.
                    </p>*/} 
                    <p className='testo_generico'>
                        {lang["Non ti scriveremo cosa facciamo"]} <br/>
                        {/*lang["Ti riassumeremo però le cose che assolutamente NON facciamo"]*/}
                        Ti riassumeremo però le cose che assolutamente <br/> <b>NON FACCIAMO</b>
                    </p>
                    <div className='button_manifesto_container'><a href="#manifesto"><button className='button_outline'>{lang['LEGGI IL MANIFESTO']}</button></a></div>
                
            </div>
        </div>
    )
}
